import {
  Form,
  Modal,
  Input,
  Button,
  Select,
  Space,
  InputNumber,
  DatePicker,
  Upload,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { useForm } from "antd/es/form/Form";
import {
  createUser,
  readItems,
  readRoles,
  readUsers,
  uploadFiles,
} from "@directus/sdk";
import { useSelector } from "react-redux";
import {
  crearValoresCampo,
  obtenerCamposUser,
} from "../../../services/formularioUsuarios";
import { InboxOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Dragger } = Upload;

function Createseller(props) {
  const [roles, setRoles] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [prestamo, setPrestamo] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedBodega, setSelectedBodega] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const [camposDinamicos, setCamposDinamicos] = useState([]);
  const [archivosPendientes, setArchivosPendientes] = useState({});

  const [form] = useForm();

  const Roles = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
        readRoles({
          fields: ["id", "name", "vende"],
          filter: {
            name: {
              _nin: ["Administrator", "adminapp"],
            },
          },
        })
      )
      .then((res) => {
        console.log(res);
        setRoles(res);
      })
      .catch((err) => console.log(err));
  };

  const Bodegas = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
        readItems("bodegas", {
          fields: ["id", "nombre"],
          filter: {
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  id: { _eq: userBodega },
                }
              : {}),
          },
        })
      )
      .then((res) => {
        console.log(res);
        setBodegas(res);
      })
      .catch((err) => console.log(err));
  };

  const getUsers = async (bodegaId) => {
    const directus = await getDirectusClient();

    directus
      .request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "email",
            "documento",
            "role.name",
            "role.id",
            "superior.id",
            "bodega.id",
            "bodega.nombre",
            "tope_de_prestamo",
            "status",
           
          ],
          limit:-1,
          filter: {
            _and: [
              {
                role: {
                  name: {
                    _neq: "clientes",
                  },
                },
              },
              {
                bodega: {
                  id: {
                    _eq: bodegaId,
                  },
                },
              },
            ],
          },
        })
      )
      .then((res) => {
        setUsers(res);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        Modal.error({
          title: "Error",
          content: "Error al obtener los usuarios",
        });
      });
  };

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    try {
      // 1. Subir archivos pendientes primero
      const valoresActualizados = { ...values };
      for (const [campoId, file] of Object.entries(archivosPendientes)) {
        const formData = new FormData();
        formData.append("file", file);
        const response = await directus.request(uploadFiles(formData));
        if (response.id) {
          valoresActualizados[campoId] = response.id; // Asignar el ID del archivo al campo
          message.success(`Imagen para ${campoId} subida correctamente`);
        }
      }

      // 2. Crear el usuario con los valores actualizados (incluyendo IDs de archivos)
      const userResponse = await directus.request(
        createUser(valoresActualizados)
      );
      console.log("Usuario creado:", userResponse);

      if (userResponse.id) {
        // 3. Guardar los valores de los campos dinámicos
        await Promise.all(
          camposDinamicos.map(async (campo) => {
            if (valoresActualizados[campo.campo]) {
              await crearValoresCampo({
                campos_users: campo.id,
                valor: valoresActualizados[campo.campo],
                user: userResponse.id,
              });
            }
          })
        );

        props.closeCreate();
        form.resetFields();
        setArchivosPendientes({}); // Limpiar archivos pendientes
        props.getSellers();
        message.success("Usuario creado exitosamente");
      }
    } catch (error) {
      console.error("Error al crear usuario o guardar campos:", error);

      // Verificar si es un error de campo duplicado (por ejemplo, email)
      const directusError = error?.errors?.[0];
      if (
        directusError &&
        directusError.extensions?.code === "RECORD_NOT_UNIQUE" &&
        directusError.extensions?.field === "email"
      ) {
        message.error("El correo electrónico ya está registrado. Por favor, utiliza uno diferente.");
      } else {
        message.error(`Error al crear el usuario`);
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleRoleChange = async (selectedRoleId) => {
    try {
      const camposUser = await obtenerCamposUser();
      const rolesConCampos = camposUser.filter((campo) =>
        campo.roles.some((rol) => rol.directus_roles_id.id === selectedRoleId)
      );

      if (rolesConCampos.length > 0) {
        console.log(
          "El rol seleccionado tiene campos asociados:",
          rolesConCampos
        );
        setCamposDinamicos(rolesConCampos);
      } else {
        console.log("El rol seleccionado no tiene campos asociados.");
        setCamposDinamicos([]);
      }
    } catch (error) {
      console.error("Error al validar campos del rol:", error);
      setCamposDinamicos([]);
    }
  };

  const handleFileChange = (campoId, file) => {
    setArchivosPendientes((prev) => ({ ...prev, [campoId]: file }));
    return false; // Evitar subida automática
  };

  const renderCampoImagen = (campo) => (
    <Dragger
      name={campo.campo}
      multiple={false}
      accept="image/*"
      beforeUpload={(file) => {
        handleFileChange(campo.campo, file);
        return false;
      }}
      showUploadList={true}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click o arrastre una imagen</p>
      <p className="ant-upload-hint">Solo imágenes (JPEG, PNG, etc.)</p>
    </Dragger>
  );

  useEffect(() => {
    Roles();
    Bodegas();
    getUsers();

    // Llamar a obtenerCamposUser y hacer log de los datos
    obtenerCamposUser()
      .then((data) => {
        console.log("Datos de campos de usuario:", data);
      })
      .catch((error) => {
        console.error("Error al obtener campos de usuario:", error);
      });
  }, []);

  return (
    <Modal
      open={props.opencreate}
      onCancel={props.closeCreate}
      title="Crear Usuario"
      footer={[
        <Button key="back" onClick={props.closeCreate}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Crear
        </Button>,
      ]}
    >
      <div style={{ margin: 20 }}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Nombre"
            name="first_name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Apellidos"
            name="last_name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Documento"
            name="documento"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Correo"
            name="email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="role" label="Rol" rules={[{ required: true }]}>
            <Select
              placeholder="seleccione un rol"
              allowClear
              onChange={(selectedRoleId) => {
                console.log(selectedRoleId);
                const selectedRole = roles.find(role => role.id === selectedRoleId);
                setSelectedRole(selectedRole);
                console.log("selectedRole",selectedRole);
                
                if (selectedRole?.vende || selectedRole?.name==="tropas") {
                  setPrestamo(true);


                } else {
                  setPrestamo(false);
                }
                handleRoleChange(selectedRoleId);
              }}
            >
              {roles?.map((rol) => {
                return (
                  <Option key={rol.id} value={rol.id}>
                    {rol.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          {selectedRole?.name === "Aliados" && (
            <Form.Item
              label="ID Remoto"
              name="idremoto"
              rules={[{ required: true, message: 'Por favor ingrese el ID Remoto' }]}
            >
              <Input />
            </Form.Item>
          )}

          <Form.Item name="bodega" label="Bodega" rules={[{ required: true }]}>
            <Select
              placeholder="seleccione una Bodega"
              allowClear
              onChange={(value) => {
                setSelectedBodega(value);
                if (value) {
                  getUsers(value);
                } else {
                  setUsers([]);
                }
                // Clear superior selection when bodega changes
                form.setFieldValue("superior", undefined);
              }}
            >
              {bodegas?.map((bodega) => (
                <Option key={bodega.id} value={bodega.id}>
                  {bodega.nombre}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="superior"
            label="Superior"
            rules={[{ required: false }]}
          >
            <Select
              placeholder="seleccione un Superior"
              allowClear
              disabled={!selectedBodega}
              showSearch
              filterOption={false}
              onSearch={(value) => {
                if (value) {
                  const filteredUsers = users.filter(user => 
                    `${user.first_name} ${user.last_name}`.toLowerCase().includes(value.toLowerCase())        
                  );
                  setUsers(filteredUsers);
                } else {
                  getUsers(selectedBodega);
                }
              }}
              style={{ width: "100%" }}
            >
              {users?.map((user) => (
                <Option key={user.id} value={user.id}>
                  {user.first_name} {user.last_name}
                  <span style={{ fontSize: "12px", color: "green" }}>
                    {user.role.name}
                  </span>
                </Option>
              ))}
            </Select>
          </Form.Item>

          {prestamo ? (
            <>
              <Form.Item
                label="Tope de prestamo"
                name="tope_de_prestamo"
                rules={[{ required: false }]}
              >
                <InputNumber />
              </Form.Item>
            </>
          ) : null}

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: false }]}
          >
            <Input />
          </Form.Item>
         
          <Form.Item
            label="Estatus"
            name="status"
            rules={[{ required: false }]}
          >
            <Select>
              <Option value="active">Activo</Option>
              <Option value="suspended">Suspendido</Option>
            </Select>
          </Form.Item>

          {camposDinamicos.map((campo) => {
            // Parsear opciones para campos de tipo 'select'
            let opcionesArray = [];
            if (campo.opciones) {
              try {
                const opcionesString = campo.opciones
                  .replace(/[{"}]/g, "")
                  .replace(/\\/g, "");
                opcionesArray = opcionesString
                  .split(",")
                  .map((op) => op.trim());
              } catch (error) {
                console.error("Error al parsear opciones:", error);
              }
            }

            return (
              <Form.Item
                key={campo.id}
                label={campo.campo}
                name={campo.campo}
                rules={[{ required: campo.tipo_campo === "obligatorio" }]}
              >
                {campo.tipo_campo === "texto" && <Input />}
                {campo.tipo_campo === "numero" && <InputNumber />}
                {campo.tipo_campo === "select" && (
                  <Select placeholder={`Seleccione ${campo.campo}`}>
                    {opcionesArray.map((opcion) => (
                      <Option key={opcion} value={opcion}>
                        {opcion}
                      </Option>
                    ))}
                  </Select>
                )}
                {campo.tipo_campo === "fecha" && (
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                )}
                {campo.tipo_campo === "imagen" && renderCampoImagen(campo)}
              </Form.Item>
            );
          })}
        </Form>
      </div>
    </Modal>
  );
}

export default Createseller;
